// Tiny fetch wrapper that throws on non-2xx and parses JSON. Works for both
// public and admin (cookie-authenticated) endpoints — admin auth is set by
// browser cookies after /dashboard/login.

export async function api(path, opts = {}) {
  const init = {
    method: opts.method || 'GET',
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    credentials: 'same-origin',
  };
  if (opts.body !== undefined) init.body = JSON.stringify(opts.body);

  const r = await fetch(path.startsWith('/') ? path : `/api/${path}`, init);
  const ct = r.headers.get('Content-Type') || '';
  const data = ct.includes('application/json') ? await r.json().catch(() => ({})) : { _raw: await r.text() };
  if (!r.ok) {
    const e = new Error(data.error || `${r.status} ${r.statusText}`);
    e.status = r.status; e.body = data;
    throw e;
  }
  return data;
}
